import { useEffect, useState } from "react";

const START = 9;
const FLOOR = 3;
let current = START;
const listeners = new Set<(n: number) => void>();
let started = false;

function start() {
  if (started) return;
  started = true;
  window.setInterval(() => {
    if (current > FLOOR) {
      current -= 1;
      listeners.forEach((l) => l(current));
    }
  }, 45000);
}

/** Shared "spots left" counter that slowly drops toward a floor. */
export function useSpotsLeft() {
  const [spots, setSpots] = useState(current);
  useEffect(() => {
    start();
    listeners.add(setSpots);
    return () => {
      listeners.delete(setSpots);
    };
  }, []);
  return { spots, total: 100 };
}
